<template>
    <div>
        <page-title>插件管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/plugin/edit">添加插件</router-link>
                        <span style="margin: 0 8px;">|</span>
                        <router-link to="/dashboard/admin/plugin/cat-index">分类管理</router-link>
                    </div>
                    <div flex>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="app_id"
                                       clearable size="mini"
                                       placeholder="应用" @change="search()">
                                <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </div>

                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column label="插件">
                    <template slot-scope="scope">
                        <div flex="dir:left">
                            <div>
                                <img :src="scope.row.pic_url" style="width: 46px;height: 46px"/>
                            </div>
                            <div style="margin-left: 10px">
                                <div>{{scope.row.display_name}}</div>
                                <div>{{scope.row.name}}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="app.display_name" label="应用"></el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column label="版本">
                    <template slot-scope="scope">
                        <template v-if="scope.row.pluginVersions[0]">
                            <router-link :to="'/dashboard/admin/plugin/version?plugin_id=' + scope.row.id">
                                {{scope.row.pluginVersions[0].version}}
                            </router-link>
                        </template>
                        <template v-else>暂无版本</template>
                        <router-link :to="'/dashboard/admin/plugin/version-edit?plugin_id=' + scope.row.id">
                            <el-button type="text" icon="el-icon-circle-plus"></el-button>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="is_open" label="开放">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_open === 1" style="color: #67C23A">已开放</span>
                        <span v-else style="color: #999">未开放</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单">
                    <template slot-scope="scope">
                        <router-link :to="'/dashboard/admin/plugin-order/index?plugin_id=' + scope.row.id">
                            {{scope.row.pluginOrdersPayCount ? scope.row.pluginOrdersPayCount.value :
                            0}}/{{scope.row.pluginOrdersCount ? scope.row.pluginOrdersCount.value : 0}}
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.is_delete === 0"
                                     :to="'/dashboard/admin/plugin/edit?id=' + scope.row.id">编辑
                        </router-link>
                        <span v-else style="color: #999">已删除</span>
                        <span class="text-split">|</span>
                        <el-button v-if="scope.row.is_delete === 0" type="text" @click="deleteItem(scope.row)">删除
                        </el-button>
                        <el-button v-else type="text" @click="recoveryItem(scope.row)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .cell div {
            display: block !important;
        }

        .cell div div {
            margin-left: 0 !important;
            text-align: center;
        }
    }
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    data() {
        return {
            app_id: null,
            loading: false,
            list: null,
            pagination: null,
            keyword: '',
            apps: [{'id': 0, 'display_name': 'SaaS平台'}]
        }
    },
    created() {
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/plugin/index',
                    params: {
                        app_id: this.app_id,
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteItem(item) {
            new Promise(resolve => {
                this.$confirm('确认删除该内容?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = 1
                delete data.pluginOrdersCount
                delete data.pluginOrdersPayCount
                this.loading = true
                axios({
                    url: 'admin/plugin/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        item.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryItem(item) {
            const data = helper.clone(item)
            data.is_delete = 0
            delete data.pluginOrdersCount
            delete data.pluginOrdersPayCount
            this.loading = true
            axios({
                url: 'admin/plugin/update',
                method: 'post',
                data: data
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    item.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        searchApps() {
            axios({
                url: 'admin/app/index'
            }).then(e => {
                if (e.data.code === 0) {
                    this.apps.push(...e.data.data.list)
                } else {
                    this.apps = []
                }
            }).catch(e => {
                this.apps = []
            })
        }
    }
}
</script>
